import {Component, Input, OnInit} from '@angular/core';
import { registerPalette } from "devextreme/viz/palette";

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.less']
})
export class PieChartComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle = '';
  dataSourceTemp: any[];
  @Input() dataSource: any[];
  @Input() argumentField: string;
  @Input() valueField: string;

  myPalette = {
    // Applies in the BarGauge, Chart, Funnel, PieChart, PolarChart, Sankey, and TreeMap with a discrete colorizer
    simpleSet: ['#dc0000', '#FFB6C1', '#005cbb','#1db2f5', '#7CFC00', '#ffc720', '#453db8', '#eb3573', '#a63db8', '#f5564a', '#f57e4a'],
};

  constructor() {
    registerPalette("myCustomPalette", this.myPalette);
  }

  ngOnInit() {
    this.dataSourceTemp = JSON.parse(JSON.stringify(this.dataSource));
    this.dataSourceTemp.sort(function (a,b) {return b.answerPercentage - a.answerPercentage});
  }

  customizeLabel = (arg: any) => {
    const dataSource = this.dataSourceTemp;
    const valueField = this.valueField;
    return {
      visible: arg.value > 0,
      backgroundColor: 'transparent',
      alignment: 'center',
      position: 'inside',
      font: {
        color: 'black',
      },
      customizeText: function (e: any) {
        let label = arg.argument;
        if (label.length > 23) {
          label = label.substring(0, 20) + '...';
        }
        return dataSource.filter(s => s[valueField] > 0).length <= 4 ? label + '\n' + e.value.toFixed(2) + '%' : e.value.toFixed(2) + '%';
      }
    };
  };

  customizeTextLegend = (arg: any) => {
    const dataSource = this.dataSourceTemp;
    let answerName = arg.pointName;
    let answerPercentage = dataSource.find(s => s[this.argumentField] === answerName)[this.valueField];
    if (answerName && answerName.length > 23) {
      answerName = answerName.substring(0, 20) + '...';
    };
    return answerName + " - " + answerPercentage + "%";
  };

  customizeTooltip = (arg: any) => {
    const text = arg.originalArgument;
    return {
      text: text
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/pie-chart/pie-chart.component.ts